import { ApiExerciseBaseItem, ApiChatDisplayableObject } from "@tt-app/models/exercise";

export const getIfChatDisplayableItem = (
  item: ApiExerciseBaseItem
): ApiChatDisplayableObject | undefined => {
  return item.type === "CHAT_CONVERSATION_USER_ANSWER" ||
    item.type === "CHAT_IMAGE" ||
    item.type === "CHAT_MESSAGE" ||
    item.type === "CHAT_TEXT" ||
    item.type === "PLAIN_TEXT"
    ? (item as ApiChatDisplayableObject)
    : undefined;
};
